import { selectSite } from '../selectors/site';
import { EVENT_TYPES, PAPER_UPLOAD_STATES, ELEMENT, INTERACTION, PAPER_UPLOAD_ID } from './constants';
import { getCharacterCount, getFileExtension, getWordCount } from '../util/helpers';
import { getViewContext } from './helpers';
export var uploadStartEvent = function uploadStartEvent(action) {
  // TODO(WTF-5622): Remove uploadStartLegacyEvent once fully migrated to new clickstream success event
  var uploadStartLegacyEvent = {
    payload: {
      type: EVENT_TYPES.PAPER_UPLOAD,
      data: {
        state: PAPER_UPLOAD_STATES.start
      }
    },
    config: {
      eventVersion: 5
    }
  };
  for (var _len = arguments.length, states = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    states[_key - 1] = arguments[_key];
  }
  var uploadStartClickstreamEvent = clickstreamInteractionEvent.apply(void 0, [{
    payload: {
      elementName: ELEMENT.NAMES.PAPER_UPLOAD,
      elementType: ELEMENT.TYPES.BUTTON,
      interactionType: INTERACTION.TYPES.START
    }
  }].concat(states));
  return [uploadStartLegacyEvent, uploadStartClickstreamEvent];
};
export var uploadEndEvent = function uploadEndEvent(action) {
  var _ref = action.payload,
    uploadId = _ref.uploadId,
    text = _ref.text,
    filename = _ref.filename;
  var wordCount = getWordCount(text);
  var characterCount = getCharacterCount(text);
  var fileType = getFileExtension(filename);

  // TODO(WTF-5622): Remove uploadEndLegacyEvent once fully migrated to new clickstream success event
  var uploadEndLegacyEvent = {
    payload: {
      type: EVENT_TYPES.PAPER_UPLOAD,
      data: {
        state: PAPER_UPLOAD_STATES.end,
        upload_id: uploadId,
        word_count: wordCount,
        character_count: characterCount,
        file_type: fileType,
        failed: false
      }
    },
    config: {
      eventVersion: 5,
      force: true
    }
  };
  for (var _len2 = arguments.length, states = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    states[_key2 - 1] = arguments[_key2];
  }
  var uploadEndClickstreamEvent = clickstreamSuccessEvent.apply(void 0, [{
    payload: {
      name: ELEMENT.NAMES.PAPER_UPLOAD_RECEIVED,
      content_id: uploadId,
      content_label: PAPER_UPLOAD_ID,
      metadata: {
        state: 'end',
        upload_id: uploadId,
        word_count: wordCount,
        character_count: characterCount,
        file_type: fileType,
        is_failed: false
      }
    }
  }].concat(states));
  return [uploadEndLegacyEvent, uploadEndClickstreamEvent];
};
export var pageViewEvent = function pageViewEvent(action, prevState, nextState) {
  var _action$payload;
  return {
    payload: {
      type: EVENT_TYPES.CLICKSTREAM_VIEW,
      data: {}
    },
    config: {
      eventVersion: 3,
      stateUpdate: {
        view: getViewContext(selectSite(nextState), action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.viewName)
      }
    }
  };
};
export var clickstreamInteractionEvent = function clickstreamInteractionEvent(action) {
  var _action$payload2 = action.payload,
    interactionType = _action$payload2.interactionType,
    elementName = _action$payload2.elementName,
    elementType = _action$payload2.elementType,
    elementRegion = _action$payload2.elementRegion,
    elementText = _action$payload2.elementText,
    elementValue = _action$payload2.elementValue;
  return {
    payload: {
      type: EVENT_TYPES.CLICKSTREAM_INTERACTION,
      data: {
        interaction: {
          element: {
            name: elementName,
            type: elementType,
            region_name: elementRegion,
            text: elementText,
            value: elementValue
          },
          type: interactionType
        }
      }
    },
    config: {
      eventVersion: 3
    }
  };
};
export var clickstreamSuccessEvent = function clickstreamSuccessEvent(action) {
  var _action$payload3 = action.payload,
    name = _action$payload3.name,
    metadata = _action$payload3.metadata,
    content_id = _action$payload3.content_id,
    content_label = _action$payload3.content_label;
  return {
    payload: {
      type: EVENT_TYPES.CLICKSTREAM_SUCCESS,
      data: {
        name: name,
        content: {
          content_id: content_id,
          content_label: content_label,
          metadata: {
            wt: {
              writing: metadata
            }
          }
        }
      }
    },
    config: {
      eventVersion: 3
    }
  };
};
export var clickstreamComponentViewEvent = function clickstreamComponentViewEvent(action) {
  var payload = action.payload,
    meta = action.meta;
  return {
    payload: {
      type: EVENT_TYPES.CLICKSTREAM_COMPONENT_VIEW,
      data: {
        component_view: {
          component: {
            name: payload.componentName,
            type: payload.componentType,
            text: meta.text
          }
        }
      }
    },
    config: {
      eventVersion: 3,
      force: false
    }
  };
};